import React from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageToggle: React.FC = () => {
    const { i18n } = useTranslation();

    return (
        <div className="flex items-center font-sans text-[13px] font-bold uppercase tracking-widest text-nav-text">
            <button
                onClick={() => i18n.changeLanguage('en')}
                className={`transition-opacity duration-200 hover:opacity-100 ${i18n.language.startsWith('en') ? 'opacity-100' : 'opacity-40'}`}
                aria-label="Switch to English"
            >
                EN
            </button>
            <span className="mx-2 text-nav-text/20 font-light">|</span>
            <button
                onClick={() => i18n.changeLanguage('es')}
                className={`transition-opacity duration-200 hover:opacity-100 ${i18n.language.startsWith('es') ? 'opacity-100' : 'opacity-40'}`}
                aria-label="Switch to Spanish"
            >
                ES
            </button>
        </div>
    );
};
